<div class="modal-header header-info">
    <h4 class="modal-title" >Attached file <span *ngIf="data['modalType'] == 'edit'">edit</span> <span *ngIf="data['modalType'] == 'view'">view</span></h4>
    <span *ngIf="showFile" (click)="attachFileDownload(fileLocation)">
            <i class="fa fa-download attach-download-icon-size" aria-hidden="true"></i>
        </span>
</div>
<div class="modal-body image-bottom" [ngClass]="imageView ?'image-alignment ':''">
    <div class="attach-body-section">
        <!-- initialize form attachedFileEditForm start -->
        <form *ngIf="attachedFileEditForm" class="attch-edit-form" [formGroup]="attachedFileEditForm" (submit)="save()">
            <!-- bind image file name -->
            <div class="">
                <label class="control-label required_field">Name</label>
                <div class="controls">
                    <input type="text" class="control-input test" formControlName="fileName">
                </div>
            </div>
            <!-- show edited tags -->
            <ng-container *ngIf="showTagDropDown">
                <div *access="['TagJobFiles.updateaccess','SetupFileTags.updateaccess']" >
                    <label class="control-label" translate>Tags</label>
                    <div class="file-tag-container select2-file-tags">
                        <input #select2EditFileTags id="editTagList" type="text" csSelect2 (selected)="selectedTag($event)" [placeholder]="'Add tags'"  [select2Config]="tagsSelect2Config" />
                    </div>
                </div>
            </ng-container>

            <div class="" *ngIf="data['modalType'] == 'edit' && showShareOnMobile">
                <div class="controls share-checkbox">
                        <input type="checkbox" formControlName="shareOnMobile">
                        <span translate>Share on mobile</span>
                </div>
            </div>
            <!-- show edited image file  -->
            <div class="control-group"  *ngIf="showFile">
                <label class="control-label required_field">
                    <span *ngIf="data['imageData'].filetype == 'PNG' || data['imageData'].filetype == 'png' || data['imageData'].filetype == 'jpg' || data['imageData'].filetype == 'jpeg' || data['imageData'].filetype == 'JPG' || data['imageData'].filetype == 'JPEG'">Image</span>
                    <span *ngIf="data['imageData'].filetype == 'pdf' || data['imageData'].filetype =='PDF'">Pdf</span>
                </label>
                <div class="controls">
                    <div class="image-preview-section" *ngIf="data['imageData'].filetype == 'PNG' || data['imageData'].filetype == 'png' || data['imageData'].filetype == 'jpg' || data['imageData'].filetype == 'jpeg' || data['imageData'].filetype == 'JPG' || data['imageData'].filetype == 'JPEG'">
                        <img alt="attach-image-edit" src="{{fileLocation}}" class="img-responsive img-fluid attach-image-alignment">
                    </div>
                    <div class="image-preview-section" *ngIf="data['imageData'].filetype == 'pdf' || data['imageData'].filetype =='PDF'">
                        <iframe class="pdf-preview-height" width="100%"  height="100%" [src]="fileLocation"></iframe>
                    </div>
                </div>
            </div>
        </form>

        <div class="control-group clearfix" *ngIf="data['modalType'] == 'view'">
            <div class="controls">
                <div class="image-margin" *ngIf="data['imageData'].filetype == 'PNG' || data['imageData'].filetype == 'png' || data['imageData'].filetype == 'jpg' || data['imageData'].filetype == 'jpeg' || data['imageData'].filetype == 'JPG' || data['imageData'].filetype == 'JPEG'">
                    <div class="image-preview-section" >
                        <img alt="attach-image-edit" src="{{fileLocation}}" class="img-responsive img-fluid attach-image-alignment">
                    </div>

                </div>
                <div class="image-preview-section" *ngIf="data['imageData'].filetype == 'pdf' || data['imageData'].filetype =='PDF'">
                    <iframe class="pdf-preview-height" width="100%" height="100%" [src]="fileLocation"></iframe>
                </div>
            </div>
        </div>
        <!-- initialize form attachedFileEditForm end -->
    </div>
</div>
<div class="modal-footer">
    <a class="btn" (click)="onCloseModal()">Cancel</a>
    <button class="btn btn-primary" *ngIf="data['modalType'] == 'edit'" [disabled]="!attachedFileEditForm.valid || action == 'saving' || action != 'save'" (click)="save()">
        <span [hidden]="action == 'saving'"  translate>Save</span>
        <span [hidden]="action != 'saving'" translate>Saving</span>
    </button>
</div>
